@if (show()) {
  <div class="announcement-banner" role="banner" [attr.dir]="isRtl() ? 'rtl' : 'ltr'">
    <img class="claude-icon" src="assets/claude-icon.svg" alt="Claude" aria-hidden="true">
    <span class="banner-text">{{ 'banner.claudeIntegration.message' | translate }}</span>
    <a
      class="banner-cta"
      [href]="ctaUrl"
      target="_blank"
      rel="noopener noreferrer"
      mat-button
      (click)="onCtaClick()"
    >{{ 'banner.claudeIntegration.cta' | translate }}</a>
    <button
      mat-icon-button
      class="dismiss-btn"
      (click)="dismiss()"
      [attr.aria-label]="'common.dismiss' | translate"
    >
      <mat-icon>close</mat-icon>
    </button>
  </div>
}
